<script>
import Portal from "../../layouts/portal";
import { clienteComputed } from "@/state/helpers";

export default {
  page: { title: "Recnet" },
  components: { Portal },
  data() {
    return {
      // Portadas de marca del carrusel (1920×499): Bienvenido, a un nuevo
      // comienzo y Comercial/Producción/Network.
      carrusel: [
        require("@/assets/images/carrusel-1.png"),
        require("@/assets/images/carrusel-2.png"),
        require("@/assets/images/carrusel-3.png"),
      ],
      // Comercios abre un acordeón en vez de navegar; este es su estado.
      comerciosAbierto: false,
      // Video "¿Qué es RecNet?". El iframe sólo se monta al abrir el modal,
      // para no cargar YouTube en cada visita y para que el video se detenga
      // al cerrar (desmontar el iframe corta la reproducción).
      mostrarVideo: false,
      videoRecnet: "https://www.youtube.com/embed/PT_M-V8R7do?autoplay=1&rel=0",
      // Los bloques que sí navegan directo (Comercios se maneja aparte).
      seccionesDirectas: [
        {
          nombre: "portal-sesiones",
          titulo: "Producciones",
          texto: "El contenido de la red en video, cuando quieras.",
          icono: "mdi mdi-play-circle",
          color: "#4b2e83",
        },
        {
          nombre: "portal-cuenta",
          titulo: "Network",
          texto: "Tu perfil, membresía, referidos y documentos.",
          icono: "mdi mdi-account-circle",
          color: "#50a5f1",
        },
      ],
    };
  },
  computed: {
    ...clienteComputed,
    /** Accesos directos a lo que vive dentro de "Comercios". */
    seccionesComercios() {
      return [
        {
          nombre: "portal-negocios",
          titulo: "Directorio",
          texto: "Comercios de la comunidad y sus promociones.",
          icono: "mdi mdi-storefront",
          color: "#34c38f",
        },
        {
          nombre: "portal-eventos",
          titulo: "Qué plan hoy",
          texto: "Lo que está pasando en la red esta semana.",
          icono: "mdi mdi-calendar-star",
          color: "#f1b44c",
        },
        {
          nombre: "portal-vacantes",
          titulo: "Vacantes",
          texto: "Oportunidades publicadas por los negocios.",
          icono: "mdi mdi-briefcase",
          color: "#50a5f1",
        },
      ];
    },
    saludo() {
      const nombre = this.nombreCliente || "";
      const primero = nombre.split(" ")[0];
      return primero ? `Hola, ${primero}` : "Hola";
    },
  },
};
</script>

<template>
  <Portal>
    <div class="portada mb-4">
      <h1 class="h3 mb-1">{{ saludo }}</h1>
      <p class="text-muted mb-0">Todo lo de Recnet, ahora también desde tu computadora.</p>
    </div>

    <b-carousel class="carrusel mb-4" :interval="5000" controls indicators fade>
      <b-carousel-slide v-for="(img, i) in carrusel" :key="i" :img-src="img" />
    </b-carousel>

    <!-- ¿Qué es RecNet? -->
    <button type="button" class="que-es mb-4" @click="mostrarVideo = true">
      <div class="que-es-play"><i class="mdi mdi-play"></i></div>
      <div class="que-es-texto">
        <h2 class="h5 mb-1">¿Qué es RecNet?</h2>
        <p class="mb-0">Conoce en un video de qué se trata la red y todo lo que puedes hacer.</p>
      </div>
      <i class="mdi mdi-chevron-right que-es-flecha"></i>
    </button>

    <b-modal v-model="mostrarVideo" title="¿Qué es RecNet?" size="lg" centered hide-footer
      body-class="p-0" @hidden="mostrarVideo = false">
      <div class="video-responsive">
        <iframe v-if="mostrarVideo" :src="videoRecnet" title="¿Qué es RecNet?" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </b-modal>

    <b-alert :show="!tieneMembresia && !cargandoCliente" variant="warning" class="mb-4">
      <strong>Tu membresía no está activa.</strong>
      Puedes ver los eventos y las vacantes, pero las sesiones y el directorio de negocios
      son parte de Recnet Plus.
      <router-link :to="{ name: 'portal-cuenta' }" class="alert-link">Actívala en Network.</router-link>
    </b-alert>

    <b-alert :show="perfilIncompleto" variant="info" class="mb-4">
      Tu registro está incompleto.
      <router-link :to="{ name: 'portal-completar' }" class="alert-link">Complétalo aquí</router-link>
      para usar todas las funciones.
    </b-alert>

    <b-row>
      <!-- Comercios no navega directo: despliega un acordeón con sus tres
           secciones para elegir. -->
      <b-col md="4" class="mb-4">
        <a href="#" class="seccion-card" :class="{ 'seccion-activa': comerciosAbierto }"
          aria-controls="acordeon-comercios" :aria-expanded="comerciosAbierto ? 'true' : 'false'"
          @click.prevent="comerciosAbierto = !comerciosAbierto">
          <div class="seccion-icono" style="background-color: #34c38f">
            <i class="mdi mdi-storefront"></i>
          </div>
          <div class="seccion-texto">
            <h2 class="seccion-titulo">Comercios</h2>
            <p class="mb-0 text-muted">Directorio, Qué plan hoy y Vacantes.</p>
          </div>
          <i class="mdi seccion-flecha" :class="comerciosAbierto ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
        </a>
      </b-col>

      <b-col v-for="s in seccionesDirectas" :key="s.nombre" md="4" class="mb-4">
        <router-link :to="{ name: s.nombre }" class="seccion-card">
          <div class="seccion-icono" :style="{ backgroundColor: s.color }">
            <i :class="s.icono"></i>
          </div>
          <div class="seccion-texto">
            <h2 class="seccion-titulo">{{ s.titulo }}</h2>
            <p class="mb-0 text-muted">{{ s.texto }}</p>
          </div>
          <i class="mdi mdi-chevron-right seccion-flecha"></i>
        </router-link>
      </b-col>
    </b-row>

    <b-collapse id="acordeon-comercios" v-model="comerciosAbierto">
      <b-row class="acordeon">
        <b-col v-for="s in seccionesComercios" :key="s.nombre" md="4" class="mb-4">
          <router-link :to="{ name: s.nombre }" class="seccion-card">
            <div class="seccion-icono" :style="{ backgroundColor: s.color }">
              <i :class="s.icono"></i>
            </div>
            <div class="seccion-texto">
              <h3 class="seccion-titulo">{{ s.titulo }}</h3>
              <p class="mb-0 text-muted small">{{ s.texto }}</p>
            </div>
          </router-link>
        </b-col>
      </b-row>
    </b-collapse>
  </Portal>
</template>

<style scoped>
.carrusel {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Las tres portadas comparten proporción (1920×499) y traen texto y logo
   integrados, así que se muestran completas —sin recortar— a lo ancho. */
.carrusel >>> .carousel-item img {
  width: 100%;
  height: auto;
  display: block;
}

.seccion-card {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  color: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

/* Banner "¿Qué es RecNet?": llama la atención sin competir con el carrusel. */
.que-es {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 18px;
  text-align: left;
  border: 0;
  border-radius: 12px;
  padding: 20px 24px;
  color: #fff;
  background: linear-gradient(135deg, #4b2e83 0%, #7b3fa0 60%, #e8622a 100%);
  box-shadow: 0 4px 14px rgba(75, 46, 131, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.que-es:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(75, 46, 131, 0.35);
}

.que-es-play {
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

/* El h2 hereda un color oscuro de los estilos de encabezado del tema; sobre el
   degradado quedaba casi invisible. Se fuerza a blanco. */
.que-es-texto h2 {
  color: #fff;
}

.que-es-texto p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
}

.que-es-flecha {
  margin-left: auto;
  font-size: 26px;
  color: rgba(255, 255, 255, 0.8);
}

/* Mantiene el video en 16:9 y llenando el ancho del modal. */
.video-responsive {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: #000;
}

.video-responsive iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.seccion-activa {
  border-color: #34c38f;
  box-shadow: 0 4px 12px rgba(52, 195, 143, 0.2);
}

/* Las tarjetas del acordeón van en amarillo para distinguirlas de las de
   arriba: dejan claro que son las opciones que se desplegaron de Comercios. */
.acordeon .seccion-card {
  background: #fff8e6;
  border-color: #f1b44c;
}

.acordeon .seccion-card:hover {
  box-shadow: 0 6px 16px rgba(241, 180, 76, 0.3);
}

.seccion-card:hover {
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.seccion-icono {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 28px;
  margin-right: 16px;
}

.seccion-texto {
  flex: 1;
}

.seccion-titulo {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 4px;
}

.seccion-flecha {
  color: #adb5bd;
  font-size: 24px;
}
</style>
